import { render, staticRenderFns } from "./OldHome.vue?vue&type=template&id=1b476bb7&scoped=true"
import script from "./OldHome.vue?vue&type=script&lang=js"
export * from "./OldHome.vue?vue&type=script&lang=js"
import style0 from "./OldHome.vue?vue&type=style&index=0&id=1b476bb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b476bb7",
  null
  
)

export default component.exports